import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import ImportCampaignConfigurationModal
	from '@/presentation/components/organisation-linking/import-campaign-configuration-modal/import-campaign-configuration-modal.vue';
import ImportCampaignConfigurationCode
	from '@/presentation/components/organisation-linking/import-campaign-configuration/import-campaign-configuration.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		ImportCampaignConfigurationModal
	},
	setup: () => {
		const code = new ImportCampaignConfigurationCode();

		return {
			isLoading: code.isLoading,
			hasLinkedOrganisations: code.hasLinkedOrganisations,
			isImportModalActive: code.isImportModalActive,
			openImportModal: code.openImportModal.bind(code)
		};
	}
});
